<template>
  <div>
    <TerceirosList :idEvento="idEvento" :terceiros="terceiros" />
  </div>
</template>

<script>
import TerceirosList from './../../../shared/components/TerceirosList.vue';

export default {
  props: ['idEvento', 'terceiros'],
  components: {
    TerceirosList,
  },
};
</script>
